import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from '../../../services/excel/excel.service';
import { HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { EvaluacionEntity } from '../../funciones/AlertaTemprana';
import { messages } from '../../funciones/mensajes';
import { CommonVariables, FuncionesMes } from '../../funciones/funcionesGenerales';
import { coberturaFinanciero, ObtenerIds } from '../idsTablas';
import moment from 'moment';
import { IMG } from '../../../services/imagen/png';
import { FiltersM, typesApex } from '../../../components/models';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { CoberturaService } from '../../../services/financiero/cobertura/cobertura.service';
import { platform } from 'os';
import { companiesFinanciero } from '../../../shared/catalogos';

@Component({
  selector: 'app-cobertura',
  templateUrl: './cobertura.component.html',
  styleUrl: './cobertura.component.css'
})
export class CoberturaComponent implements OnInit {
  @ViewChildren(GraficadorComponent) grafCmp!: QueryList<GraficadorComponent>;
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  public tipoGraf = typesApex;
  public datosGraficador: any[] = []; // Formato: [{name: string, data: number[]}]
  public etiquetasGraf: string[] = []; // Etiquetas del eje X
  public tipoGrafActual = this.tipoGraf.AREA; // Tipo actual de gráfica
  public showLabelsGraf = false; // Mostrar etiquetas
  public colorScheme = ['#004A97', '#68B4D6', '#82CC60', '#FFCB03', '#FC8A33', '#F74C58'];

  public Filters = FiltersM;

  private numEvaluaciones = 1;
  /*Filtros*/
  public cadenaEvaluacion = [];
  public Periodos = [];
  /*Titulos y subtitulos*/
  public subTitles = '';
  public subTitles2 = '';
  /*Entidades*/
  private evaluacionEntity = new EvaluacionEntity;
  /*Datos*/
  private dataAnios = [];
  public dataTabla = [];
  public dataTotal = [];
  public cuentasTotal : Record<string, any[]> = {};
  public ingresos: number;
  public salcoberturaC = {nombre: '', dato: 0};
  public salcoberturaS = {nombre: '', dato: 0};
  /*Datos graficas*/
  public dataRadar = [];
  public tipo = 'area';

  public graf1 = false;

  public miles = ',';
  public decimal = '.';
  public modalOpen: boolean = false;
  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private exportExcel: ExcelService,
    private coberturaService: CoberturaService,
  ) {
    this.evaluacionEntity = new EvaluacionEntity;
    this.evaluacionEntity.Id_Plantilla = Number(this.cookieService.get('idPlanFin'));
    this.evaluacionEntity.Id_Institucion = Number(cookieService.get('idInstitucion'));
  }

  async ngOnInit(): Promise<void> {
    await this.getEvaluacion();
  }

  /*Consultas*/
  private async getEvaluacion() {
    try {
      const evaluaciones = await this.coberturaService.getEvaluacionesByPlantilla(
        this.evaluacionEntity.Id_Plantilla
      );
      this.ordenamientoDataEvaluacion([].concat(evaluaciones));
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  /*Obtención de datos*/
  private ordenamientoDataEvaluacion(datos) {
    const info = CommonVariables.obtenerPeriodos(datos, this.numEvaluaciones);
    this.Periodos = info.periodos;
    for (const an of this.Periodos) {
      if (an.anio < 2023) {
        an.visible = false;
      }
    }
    this.obtenerDataAnio();
    this.obtenerDataEvaluacion();
  }
  private async obtenerDataAnio() {
    const promises = [];
    for (var anios = 1; anios <= 5; anios++) {
      let ann, mess;
      for (const an of this.Periodos) {
        for (const mes of an.series) {
          if (mes.check) {
            ann = mes.an;
            mess = mes.mes;
          }
        }
      }
      if (mess !== 'dic') {
        ann = ann - anios;
      } else {
        ann = ann - (anios - 1);
      }

      const an = this.Periodos.find(a => a.anio === ann);
      if (an) {
        const ev = an.series.find(m => m.mes === 'dic');
        const promise = this.coberturaService.getAnioPorEvaluacion(ev.id)
          .then((value) => {
            this.dataAnios.push({ id: ev.id, value: value });
          })
          .catch(err => {
            messages.errorMessageGraph(err);
          });
        promises.push(promise);
      }
    }
    await Promise.all(promises);
  }
  /* Obtención de periodos */
  private obtenerDataEvaluacion() {
    this.cadenaEvaluacion = [];
    this.subTitles = "";
    var tot = 0;
    for (var i = this.Periodos.length - 1; i >= 0; i--) {
      if (this.Periodos[i].visible) {
        for (var j = this.Periodos[i].series.length - 1; j >= 0; j--) {
          if (this.Periodos[i].series[j].check || (tot > 0 && tot < 12)) {
            this.cadenaEvaluacion.push({
              evaluacion: this.Periodos[i].series[j].periodo,
              anio: this.Periodos[i].series[j].an,
              mes: this.Periodos[i].series[j].mes,
              idEvaluacion: this.Periodos[i].series[j].id,
              porcentaje: '%',
              pos: this.Periodos[i].series[j].pos
            });
            tot++;
          }
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.subTitles2 = this.cadenaEvaluacion[this.cadenaEvaluacion.length - 1].evaluacion + ' - ' + this.cadenaEvaluacion[0].evaluacion;
    this.getCuentas()
  }
  private async getCuentas(){
    try{
      const todosLosPeriodos = this.Periodos
        .filter(p => p.utilizable)
        .flatMap(p =>
          p.series
            .filter(s => s.utilizable)
            .map(s => ({
              anio: p.anio,
              mes: s.mes,
              idEvaluacion: s.id,
              check: s.check
            }))
      );
    const indexSeleccionado = todosLosPeriodos.findIndex(p => p.check === true);
    const ultimos12 = todosLosPeriodos.slice(
      Math.max(0, indexSeleccionado - 11),
      indexSeleccionado + 1
    );
    const diciembres = todosLosPeriodos 
      .slice(0, indexSeleccionado)
      .filter(p => p.mes === 'dic')
      .reverse()
      .filter(
        (p, i, arr) =>
          arr.findIndex(x => x.anio === p.anio) === i
      )
      .slice(0, 3);
      const periodos = [...ultimos12,...diciembres.filter(d => !ultimos12.some(p => p.idEvaluacion === d.idEvaluacion))];

      this.cuentasTotal = {};
      const cobertura = coberturaFinanciero.cuentasCobertura(
        this.evaluacionEntity.Id_Plantilla
      );
      if(cobertura === undefined){
        var nombre = companiesFinanciero.find(c => Number(c.id) === Number(this.cookieService.get('idInstitucion'))).name;
        messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
      }
      await this.agregarACuentasTotal(
        cobertura.cuentas,
        periodos,
        this.coberturaService.getDetalleCuenta.bind(this.coberturaService),
        'detalleEvaluacionCuenta',
        'idCuenta',
        this.cuentasTotal
      );

      await this.agregarACuentasTotal(
        cobertura.varTemp,
        periodos,
        this.coberturaService.getVarTemp.bind(this.coberturaService),
        'detalleEvaluacionVarTemp',
        'idVarTemp',
        this.cuentasTotal
      );

      await this.agregarACuentasTotal(
        cobertura.var,
        periodos,
        this.coberturaService.getVariable.bind(this.coberturaService),
        'detalleEvaluacionVariable',
        'idVariable',
        this.cuentasTotal
      );

      this.dataTablero(periodos);
    }catch(e){
      console.warn(e);
    }
  }
  private async agregarACuentasTotal<T>(cuentas: string[],periodos: any[],servicio: (idEval: number, id: string) => Promise<any>,
    detalleKey: string, idKey: string, cuentasTotal: Record<string, T[]>) {
    const promesas = periodos.flatMap(periodo =>
      cuentas.map(id =>
        servicio(periodo.idEvaluacion, id)
      )
    );
    const resultados = await Promise.all(promesas);
    resultados.forEach(r => {
      const detalle = r?.[detalleKey];
      if (!detalle) return;
      const idCuenta = detalle[idKey];
      cuentasTotal[idCuenta] ??= [];
      cuentasTotal[idCuenta].push(detalle);
    });
  }
  private dataTablero(periodos){
    const indCapitalizacion = [
      {nombre: 1, desde: 0, hasta: 120},
      {nombre: 2, desde: 120, hasta: 160},
      {nombre: 3, desde: 160, hasta: 200},
      {nombre: 4, desde: 200, hasta: undefined},
    ]
    this.dataTabla = [];
    var enc = coberturaFinanciero.encabezados(this.evaluacionEntity.Id_Plantilla);
    var i = 0;
    this.ingresos = 0;
    for (const d of enc){
      if(d.nombre == 'Ingreso financiero'){
        this.ingresos = i;
        for(let i = 0; i < periodos.length; i++){
          if(periodos[i].mes === 'dic'){
            this.dataTabla.push({
              concepto:'',
              anio:  periodos[i].anio,
              monto: d.monto !== undefined ? this.calcularFormula(d, d.monto, periodos[i].idEvaluacion) : '',
              porcen: d.porcentaje ?? '',
              tot: '',
              nivel: 3
            });
          }
        }
      }else if(d.nivel == 1){
        this.dataTabla.push({
          concepto: d.nombre,
          anio: "",
          monto: "",
          porcen: d.porcentaje ?? '',
          tot: d.total !== '-' && d.total !== undefined ? this.calcularFormula(d, d.total, this.cadenaEvaluacion[0].idEvaluacion) : "",
          nivel: d.nivel
        });
      }else if(d.nivel == 2){
        this.dataTabla.push({
          concepto: d.nombre,
          anio: "",
          monto: d.monto !== undefined ? this.calcularFormula(d, d.monto, this.cadenaEvaluacion[0].idEvaluacion) : '',
          porcen: d.porcentaje ?? '',
          tot: d.total !== '-' && d.total !== undefined ? this.calcularFormula(d, d.total, this.cadenaEvaluacion[0].idEvaluacion) : "",
          nivel: d.nivel
        });
      }else if(d.nivel == 3){
        var p = 0, suma = 0;
        for(let i = 1; i <= 3; i++){
          if(this.dataTabla[this.dataTabla.length-i].concepto === ''){
            suma += this.dataTabla[this.dataTabla.length-i].monto;
            p++;
          }
        }
        //TODO: si ya hay datos para dic 23 se debe eliminar este if 
        var nombre = companiesFinanciero.find(c => Number(c.id) === Number(this.cookieService.get('idInstitucion'))).name;
        if(nombre === 'ADICLA'){
          this.dataTabla.push({
            concepto:'',
            anio:  '2023',
            monto: 45308755,
            porcen: '',
            tot: '',
            nivel: 3
          });
        }        
        this.dataTabla.push({
          concepto: d.nombre,
          anio: d.nombre,
          monto: suma/p,
          porcen: d.porcentaje ?? '',
          tot: (suma/p) * (d.porcentaje/100),
          nivel: d.nivel
        });
        //actualizar el total 
        const i = this.dataTabla.findIndex(d => d.concepto === '÷ Requerimiento de capital total');
        const k = this.dataTabla.findIndex(d => d.concepto === 'Patrimonio computable');
        this.dataTabla[i].tot = 0;
        var sumaSC = 0;
        for(let j = i; j < this.dataTabla.length; j++){
          this.dataTabla[i].tot += Number(this.dataTabla[j].tot);
          if(j !== this.dataTabla.length-1){
            sumaSC += Number(this.dataTabla[j].tot)
          }
        }         
        this.salcoberturaC.dato = Number(
          (((this.dataTabla[k].tot / this.dataTabla[i].tot) * 100).toFixed(0))
        );
        this.salcoberturaS.dato = Number(((this.dataTabla[k].tot / sumaSC)*100).toFixed(0));        
      }
      i++;
    } 
    for(const i of indCapitalizacion){
      if(i.hasta !== undefined){
        if(this.salcoberturaC.dato >= i.desde && this.salcoberturaC.dato < i.hasta){
          this.salcoberturaC.nombre = this.translate.instant('financiero.coberturaRiesgos.titTarjeta'+i.nombre);
        }
        if(this.salcoberturaS.dato >= i.desde && this.salcoberturaS.dato < i.hasta){
          this.salcoberturaS.nombre = this.translate.instant('financiero.coberturaRiesgos.titTarjeta'+i.nombre);;
        }
      }else{
        this.salcoberturaC.nombre = this.salcoberturaC.nombre === '' ? this.translate.instant('financiero.coberturaRiesgos.titTarjeta'+i.nombre) : this.salcoberturaC.nombre;
        this.salcoberturaS.nombre = this.salcoberturaS.nombre === '' ? this.translate.instant('financiero.coberturaRiesgos.titTarjeta'+i.nombre) : this.salcoberturaS.nombre;
      }
    }
    this.dataGrafica(periodos);
  }
  private calcularFormula(dato: any, formula: string, idEvaluacion): number {
    const elements = formula.trim().split(' ');
    // Caso simple: solo un elemento
    if (elements.length === 1) {
      return this.resolverOperando(elements[0], dato, idEvaluacion);
    }
    let resultado = this.resolverOperando(elements[0], dato, idEvaluacion);
    for (let i = 1; i < elements.length; i += 2) {
      const operador = elements[i];
      const siguiente = this.resolverOperando(elements[i + 1], dato, idEvaluacion);
      switch (operador) {
        case '+':
          resultado += siguiente;
          break;
        case '-':
          resultado -= siguiente;
          break;
        case '*':
          resultado *= siguiente;
          break;
        case '/':
          resultado = siguiente !== 0 ? resultado / siguiente : 0;
          break;
        default:
          console.warn(`Operador no soportado: ${operador}`);
          return 0;
      }
    }
    return resultado;
  }
  private resolverOperando(operando: string, dato: any, idEvaluacion): number {
    let signo = 1;
    // operador unario negativo
    if (operando.startsWith('-')) {
      signo = -1;
      operando = operando.substring(1);
    }
    // número literal
    if (!isNaN(Number(operando))) {
      return Number(operando);
    }
    // keywords especiales
    if (operando === 'porcentaje') {
      return (dato.porcentaje ?? 0) / 100;
    }
    if (operando === 'monto') {
      return dato.monto ?? 0;
    }
    // idCuenta
    const cuenta = this.cuentasTotal[operando];
    if (!cuenta || !cuenta.length) {
      console.warn(`Cuenta no encontrada: ${operando}`);
      return 0;
    }
    const valor = this.cuentasTotal[operando].find( d => d.idEvaluacion === idEvaluacion).valor;
    return signo * valor;
  }
  private dataGrafica(periodos){
    var enc = coberturaFinanciero.encabezados(this.evaluacionEntity.Id_Plantilla);
    var auxCR = [], auxSR = [], encPer = [];
    for(const per of periodos){
      encPer.push(`${per.mes} ${per.anio.toString().slice(-2)}`);
      var auxTabla = [], i = 0;
      for (const d of enc){
        if(d.nombre == 'Ingreso financiero'){
          for(let i = 0; i < periodos.length; i++){
            if(periodos[i].mes === 'dic'){
              auxTabla.push({
                concepto:'',
                anio:  periodos[i].anio,
                monto: d.monto !== undefined ? this.calcularFormula(d, d.monto, periodos[i].idEvaluacion) : '',
                porcen: d.porcentaje,
                tot: '',
                nivel: 3
              });
            }
          }
        }else if(d.nivel == 1){
          auxTabla.push({
            concepto: d.nombre,
            anio: "",
            monto: "",
            porcen: d.porcentaje,
            tot: d.total !== '-' && d.total !== undefined ? this.calcularFormula(d, d.total, per.idEvaluacion) : "",
            nivel: d.nivel
          });
        }else if(d.nivel == 2){
          auxTabla.push({
            concepto: d.nombre,
            anio: "",
            monto: d.monto !== undefined ? this.calcularFormula(d, d.monto, per.idEvaluacion) : '',
            porcen: d.porcentaje,
            tot: d.total !== '-' && d.total !== undefined ? this.calcularFormula(d, d.total, per.idEvaluacion) : "",
            nivel: d.nivel
          });
        }else if(d.nivel == 3){
          var p = 0, suma = 0;
          for(let i = 1; i <= 3; i++){
            if(auxTabla[auxTabla.length-i].concepto === ''){
              suma += auxTabla[auxTabla.length-i].monto;
              p++;
            }
          }
          auxTabla.push({
            concepto: d.nombre,
            anio: d.nombre,
            monto: suma/p,
            porcen: d.porcentaje,
            tot: (suma/p) * (d.porcentaje/100),
            nivel: d.nivel
          });
          //actualizar el total 
          const i = auxTabla.findIndex(d => d.concepto === '÷ Requerimiento de capital total');
          const k = auxTabla.findIndex(d => d.concepto === 'Patrimonio computable');
        auxTabla[i].tot = 0;
          var sumaSC = 0;
          for(let j = i; j < auxTabla.length; j++){
            auxTabla[i].tot += Number(auxTabla[j].tot);
            if(j !== auxTabla.length-1){
              sumaSC += Number(auxTabla[j].tot)
            }
          } 
          auxCR.push(Number((auxTabla[k].tot / auxTabla[i].tot)*100).toFixed(0));
          auxSR.push(Number((auxTabla[k].tot / sumaSC)*100).toFixed(0));
        }
        i++;
      } 
      if(per.check){ // periodo actual        
        break;
      }
    }
    this.datosGraficador = [
      {
        name: "Cobertura sin riesgo operativo",
        data: auxSR
      },
      {
        name: "Cobertura con riesgo operativo",
        data: auxCR
      }
    ];
    this.etiquetasGraf = encPer;
    this.optionsGraf(this.tipo);    
  }
  /*Filtros*/
  public async cambioPeriodo(per) {
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        if (mes.periodo === per.periodo) {
          mes.check = true;
        } else {
          mes.check = false;
        }
      }
    }
    await this.obtenerDataAnio();
    this.obtenerDataEvaluacion();
  }
  /* acciones en filtros */
  public numPerSelect() {
    var selecc = 0;
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        if (mes.check) {
          selecc++;
        }
      }
    }
    if (selecc > 1)
      return true;
    return false;
  }
  /* Cambio de graficas */
  public optionsGraf(tipo) {
    if (!tipo) {
      tipo = 'area';
    }
    // Cambiar el tipo de gráfica
    switch (tipo) {
      case 'bar':
        this.tipoGrafActual = this.tipoGraf.BAR;
        break;
      case 'line':
        this.tipoGrafActual = this.tipoGraf.LINE;
        break;
      case 'area':
      default:
        this.tipoGrafActual = this.tipoGraf.AREA;
        break;
    }
    this.tipo = tipo;
  }

  public cambiarTipoGrafica(tipo: string) {
    this.optionsGraf(tipo);
  }
  /* formateo de datos */
  public escrituraPer(Periodo) {
    if (Periodo.split(' ').length === 2) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    } else if (Periodo.split(' ').length === 5) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1] + ' ' + datos[2] + ' ' + this.translate.instant('filtros.' + datos[3]) + ' ' + datos[4];
    }
    return Periodo;
  }
  /* Modales */
  public openModal(modal) {
    this.graf1 = false;
    switch (modal) {
      case 'graf1':
        this.graf1 = true;
        this.modalOpen = true;
        break;
    }
  }
  public closeModal() {
    document.getElementById("ampliar")!.style.display = "none";
  }
  public clickFuera(event) {
    if (event.target === document.getElementById("ampliar")) {
      this.closeModal();
    }
  }

  public exportarExcel() {
    var titulos = [], datos = [], nivel = [];

    titulos.push(this.translate.instant('financiero.coberturaRiesgos.titulo1Tabla'));
    titulos.push(this.translate.instant('financiero.coberturaRiesgos.titulo2Tabla'));
    titulos.push(this.translate.instant('financiero.coberturaRiesgos.titulo3Tabla'));
    titulos.push(this.translate.instant('financiero.coberturaRiesgos.titulo4Tabla'));

    for (const d of this.dataTabla) {
      var aux = [];
      aux.push(d.concepto + d.anio);
      aux.push(Number(d.monto));
      aux.push(d.porcen !== undefined ? d.porcen / 100 : '');
      aux.push(Number(d.tot));
      datos.push(aux);
      nivel.push(d.nivel);
    }

    let tituloHoja = this.translate.instant('financiero.coberturaRiesgos.titulo1') + " | " + this.escrituraPer(this.subTitles)
    this.exportExcel.excelFinancieroCoberRiesgo(tituloHoja, titulos, datos, this.translate.instant('financiero.coberturaRiesgos.titulo1') + " " + this.escrituraPer(this.subTitles), nivel);
  }

  public exportarGraf(id : number, nombre) {
   var name = { 
      titulo: this.translate.instant('menu.'+this.dataService.subModuleSelect),
      subtitulo: this.translate.instant(nombre) + " " + this.escrituraPer(this.subTitles2),
      nombreArch: this.translate.instant('menu.'+this.dataService.subModuleSelect)
    }
    
    const comp = this.grafCmp.find(g => g.zona === id);
    comp.exportImg(id,name);
  }

  public capitalizacionTexto(text: string): string | undefined {
    if (!text) return undefined;
    text = text.trim();
    if (text.endsWith('.')) text = text.slice(0, -1);
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }
}
